import React from 'react'
import Button from 'app/components/ButtonDefault'
import { withTranslation } from 'react-i18next'
import { IProtrackItemProps } from './interface';
import './styles.scss'

const bc = 'protrack-item'

const ProTrackItem: React.FC<IProtrackItemProps> = ({ t, image, proTrackName, welcomeText, setQueriesAndGoToDashboard, color, id }) => (
  <div className={`${bc}__wrapper`}>
    <div className={`${bc}__left`} style={{ backgroundColor: color }}>
      <img className={`${bc}__image`} src={image} alt={proTrackName} />
    </div>
    <div className={`${bc}__right`}>
      <Button primary className={`${bc}__button`} onClick={() => setQueriesAndGoToDashboard(id)}>
        {t('Start')} {proTrackName}
      </Button>
      <span className={`${bc}__description`}>{welcomeText}</span>
    </div>
  </div>
)

ProTrackItem.defaultProps = {
  color: '#fff',
}

export default withTranslation('user')(ProTrackItem)
